import { getStoredPlatformId, PLATFORM_LST } from "@/utils/apiPlatform";

const LEGACY_TOKEN = "lst_token";
const LEGACY_PHONE = "lst_phone";

function tokenKey(platformId) {
    return `lst_token__${platformId}`;
}
function phoneKey(platformId) {
    return `lst_phone__${platformId}`;
}

let _legacyMigrated = false;
function migrateLegacyOnce() {
    if (_legacyMigrated)
        return;
    _legacyMigrated = true;
    try {
        const legacyT = localStorage.getItem(LEGACY_TOKEN);
        const legacyP = localStorage.getItem(LEGACY_PHONE);
        if (!legacyT && !legacyP)
            return;
        const tk = tokenKey(PLATFORM_LST);
        const pk = phoneKey(PLATFORM_LST);
        if (!localStorage.getItem(tk) && legacyT)
            localStorage.setItem(tk, legacyT);
        if (!localStorage.getItem(pk) && legacyP)
            localStorage.setItem(pk, legacyP);
    }
    catch (e) {
    }
}

export function getLstToken(platformId = getStoredPlatformId()) {
    migrateLegacyOnce();
    try {
        const v = localStorage.getItem(tokenKey(platformId));
        if (v)
            return v;
        if (platformId === PLATFORM_LST) {
            const leg = localStorage.getItem(LEGACY_TOKEN);
            if (leg)
                return leg;
        }
        return "";
    }
    catch (e) {
        return "";
    }
}

export function getLstPhone(platformId = getStoredPlatformId()) {
    migrateLegacyOnce();
    try {
        const v = localStorage.getItem(phoneKey(platformId));
        if (v)
            return v;
        if (platformId === PLATFORM_LST) {
            const leg = localStorage.getItem(LEGACY_PHONE);
            if (leg)
                return leg;
        }
        return "";
    }
    catch (e) {
        return "";
    }
}

export function setLstSession(token, phone, platformId = getStoredPlatformId()) {
    try {
        const t = token != null ? String(token).trim() : "";
        const p = phone != null ? String(phone).trim() : "";
        if (t)
            localStorage.setItem(tokenKey(platformId), t);
        else
            localStorage.removeItem(tokenKey(platformId));
        if (p)
            localStorage.setItem(phoneKey(platformId), p);
        else
            localStorage.removeItem(phoneKey(platformId));
        if (platformId === PLATFORM_LST) {
            if (t) {
                localStorage.setItem(LEGACY_TOKEN, t);
            }
            else {
                localStorage.removeItem(LEGACY_TOKEN);
            }
            if (p) {
                localStorage.setItem(LEGACY_PHONE, p);
            }
            else {
                localStorage.removeItem(LEGACY_PHONE);
            }
        }
    }
    catch (e) {
    }
}

export function clearLstSession(platformId = getStoredPlatformId()) {
    try {
        localStorage.removeItem(tokenKey(platformId));
        localStorage.removeItem(phoneKey(platformId));
        if (platformId === PLATFORM_LST) {
            localStorage.removeItem(LEGACY_TOKEN);
            localStorage.removeItem(LEGACY_PHONE);
        }
    }
    catch (e) {
    }
}
